<template>
    <v-container id="selectorcuenta-caplp">
      <v-row>
        <v-col cols="1" md="1" lg="1">
          <v-text-field
            v-model="numero"
            label="N°"
            type="number"
            v-on:keyup.enter="BuscarCuenta"
            height="20px"
          />
        </v-col>
        <v-col cols="2" md="2" lg="2">
          <v-text-field
            v-model="codigo"
            label="Código"
            v-on:keyup.enter="BuscarCuenta"
            height="20px"
          />
        </v-col>
        <v-col cols="5" md="6" lg="6">
          <v-text-field
            v-model="descripcion"
            label="Concepto"
            v-on:keyup.enter="BuscarCuenta"
            height="20px"
          />
        </v-col>
        <v-col cols="4" md="3" lg="3">
          <v-btn
            class="ma-2"
            fab
            dark
            x-small
            color="primary"
            title="Buscar"
            @click="BuscarCuenta"
          >
            <v-icon
              dark
            >
              mdi-magnify
            </v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            fab
            dark
            x-small
            color="primary"
            title="Quitar Cuenta"
            @click="QuitarCuenta"
          >
            <v-icon
              dark
            >
              mdi-cancel
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialogseleccionar" persistent max-width="1024">
        <v-card>
          <v-card-title class="headline">
            Seleccione Cuenta
          </v-card-title>
          <v-card-actions>
            <v-btn color="red darken-1" text @click="dialogseleccionar = false">
              Cerrar
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-data-table
              :headers="columnas"
              :items="lista"
              :items-per-page="10"
              :footer-props="{'items-per-page-text': 'Filas por Página:',
                              'items-per-page-all-text' : 'Todos'}"
              class="elevation-1"
              dense
              no-data-text="Sin Registros"
              multi-sort
              >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="seleccionar(item)"
                >
                  mdi-arrow-right
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  <script>
    import axios from '@/axios'
    export default {
      props: ['idseleccionado', 'soloimputables'],
      data() {
        return {
          loading: false,
          dialogmensaje: false,
          mensajetitulo: '',
          mensajecuerpo: '',
          numero: '',
          codigo: '',
          descripcion: '',
          lista: [],
          dialogseleccionar: false,
          columnas: [
            {
              text: 'Op.',
              align: 'center',
              value: 'actions',
              sortable: false,
              width: 100
            },
            {
              text: 'ID',
              align: 'center',
              sortable: true,
              value: 'cuenta',
              width: 15
            },
            {
              text: 'Número',
              align: 'center',
              sortable: true,
              value: 'numero',
              width: 110
            },
            {
              text: 'Código',
              align: 'center',
              sortable: true,
              value: 'codigo',
              width: 100
            },
            {
              text: 'DH',
              align: 'center',
              sortable: true,
              value: 'dh',
              width: 100
            },
            {
              text: 'Descripción',
              align: 'center',
              sortable: true,
              value: 'descripcion',
              width: 200
            }
          ],
        }
      },
      mounted() {
        this.numero='';
        this.codigo='';
        this.descripcion='';
        if(this.idseleccionado!=null && this.idseleccionado!=0){
          this.BuscarCuenta();
        }
      },
      methods: {
        MostrarMensaje(titulo, cuerpo) {
          this.mensajetitulo = titulo;
          this.mensajecuerpo = cuerpo;
          this.dialogmensaje = true;
        },
        BuscarCuenta () {
          this.loading = true
          var nro= this.numero!='' ? this.numero : '0'
          var cod= this.codigo!='' ? + this.codigo : ' '
          var des= this.descripcion!='' ? this.descripcion : ' '
          var id= this.idseleccionado!=null && this.idseleccionado!=0 ? this.idseleccionado : '0';
          var soloimp= this.soloimputables!=null ? this.soloimputables : '0';
          axios.get('cuenta/' + cod + '/' + des + '/' + nro + '/' + id + '/' + soloimp)
            .then((result) => {
              if (result.data.resultado===0){
                this.lista = result.data.datos;
                if(this.lista.length===0)
                {
                    this.QuitarCuenta();
                    this.MostrarMensaje('Atención','No existen cuentas con los criterios seleccionados!!!')
                }
                else if(this.lista.length===1)
                {
                    this.numero= this.lista[0].numero
                    this.codigo= this.lista[0].codigo
                    this.descripcion= this.lista[0].descripcion
                    this.$emit('selCuenta', this.lista[0])
                }else{
                    /*abre cuadro con lista para seleccionar*/
                    this.dialogseleccionar=true
                }
                this.loading = false
              }else{
                this.loading = false
                this.MostrarMensaje('Error',result.data.resultadomensaje,false);
              }
            })
            .catch((error) => {
              this.QuitarCuenta();
              this.loading = false
              this.MostrarMensaje('Error', error)
            })
        },
        QuitarCuenta () {
          this.numero=''
          this.codigo=''
          this.descripcion=''
          this.lista=[]
          this.idseleccionado=0;
          this.$emit('selCuenta', null)
        },
        seleccionar (item) {
          this.loading=true
          this.numero= item.numero
          this.codigo= item.codigo
          this.descripcion= item.descripcion
          this.$emit('selCuenta', item)
          this.dialogseleccionar=false
          this.loading=false
        }
      }
    };
  </script>
  <style>
    .textocentrado {
      text-align: center;
    }
    .elementocentrado {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .col-xl,
    .col-xl-auto,
    .col-xl-12,
    .col-xl-11,
    .col-xl-10,
    .col-xl-9,
    .col-xl-8,
    .col-xl-7,
    .col-xl-6,
    .col-xl-5,
    .col-xl-4,
    .col-xl-3,
    .col-xl-2,
    .col-xl-1,
    .col-lg,
    .col-lg-auto,
    .col-lg-12,
    .col-lg-11,
    .col-lg-10,
    .col-lg-9,
    .col-lg-8,
    .col-lg-7,
    .col-lg-6,
    .col-lg-5,
    .col-lg-4,
    .col-lg-3,
    .col-lg-2,
    .col-lg-1,
    .col-md,
    .col-md-auto,
    .col-md-12,
    .col-md-11,
    .col-md-10,
    .col-md-9,
    .col-md-8,
    .col-md-7,
    .col-md-6,
    .col-md-5,
    .col-md-4,
    .col-md-3,
    .col-md-2,
    .col-md-1,
    .col-sm,
    .col-sm-auto,
    .col-sm-12,
    .col-sm-11,
    .col-sm-10,
    .col-sm-9,
    .col-sm-8,
    .col-sm-7,
    .col-sm-6,
    .col-sm-5,
    .col-sm-4,
    .col-sm-3,
    .col-sm-2,
    .col-sm-1,
    .col,
    .col-auto,
    .col-12,
    .col-11,
    .col-10,
    .col-9,
    .col-8,
    .col-7,
    .col-6,
    .col-5,
    .col-4,
    .col-3,
    .col-2,
    .col-1 {
      padding: 2px !important;
    }
    @media only screen and (min-width: 960px) {
      .altojusto {
        height: 45px !important;
      }
    }
    .alineaizquierda {
      text-align: left !important;
    }
    .alineacentro {
      text-align: center;
    }
    .alineaderecha {
      text-align: right;
    }
    .ocupa10 {
      width: 10%;
    }
    .ocupa20 {
      width: 20%;
    }
    .ocupa30 {
      width: 30%;
    }
    .ocupa50 {
      width: 50%;
    }
    .ocupa75 {
      width: 75%;
    }
    .ocupa95 {
      width: 95%;
    }
    .centradovertical {
      vertical-align: middle;
      align-items: center;
    }
    .abajovertical {
      vertical-align: bottom;
    }
    .TituloGrilla {
      font-family: Tahoma;
      font-size: medium;
      font-weight: bold;
      background-color: darkgray;
    }
    .textoNegritaRojo {
      color:red !important;
      font-weight:bold !important;
    }
    .textoNegritaVerde{
      color:rgb(83, 248, 125) !important;
      font-weight:bold !important;
    }
  </style>